'use strict'

import axios from 'axios'

import * as types from '../store/mutation-types'
import store from '../store'
import router from '../router'
import config from '../config'

axios.defaults.timeout = 10000
axios.defaults.baseURL = config.apiHost + '/api/'

axios.interceptors.request.use(
  config => {
    if (config.token) {
      config.headers.Authorization = `Bearer ${config.token}`
      delete config.token
    }
    return config
  },
  err => Promise.reject(err)
)

axios.interceptors.response.use(
  response => {
    if (response.status !== 200) {
      return Promise.reject(new Error(`Status text: ${response.statusText}, code: ${response.status}`))
    }
    if (!response.data) {
      return Promise.reject(new Error('no response data found'))
    }
    const { error, status } = response.data
    if (error) {
      return Promise.reject(new Error(`${error}, status: ${status || -1}`))
    }
    return response.data
  },
  error => {
    if (error.response) {
      switch (error.response.status) {
        case 401:
          store.commit(types.LOGOUT)
          router.replace({
            path: 'login',
            query: {
              redirect: router.currentRoute.fullPath
            }
          })
      }
    }
    return Promise.reject(error)
  }
)

export default axios



// WEBPACK FOOTER //
// ./src/libs/network.js